<template>
  <v-chip label :small='!small' :xSmall='small' :color='$store.state.icons.archive.iconColor'>
    <v-icon :small='!small' :xSmall='small' left>{{ $store.state.icons.archive.icon }}</v-icon>
    Archived
  </v-chip>
</template>

<script>
export default {
  name: 'wc-archived',
  props: {
    small: {
      required: false,
      type: Boolean,
      default: false
    }
  }
}
</script>
